import { render, staticRenderFns } from "./config-section.vue?vue&type=template&id=1fd23238&scoped=true"
import script from "./config-section.vue?vue&type=script&lang=js"
export * from "./config-section.vue?vue&type=script&lang=js"
import style0 from "./config-section.vue?vue&type=style&index=0&id=1fd23238&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd23238",
  null
  
)

export default component.exports